<template>
    <div id="lt-yantr" class="mortgage-cta yantr-tracking">
        <div class="container-width" :class="mode">
            <h3>{{ Title }}</h3>
            <ul class="filter-block">
                <li>
                    <drop-down
                        v-model="LoanType"
                        :label="labelLoanType"
                        :options="LoanTypeMortgageCTAList"
                        @input="UpdateFilters()"
                    />
                </li>
                <li>
                    <label>{{ labelZipCode }}</label>
                    <zip-code-input
                        v-model="ZipCode"
                        placeholder=""
                        @input="getLocationByZip"
                    />
                    <span v-show="ShowZipCodeError" class="error-msg font-sm">Please enter a valid zip code.</span>
                </li>
                <li v-show="ShowPurchaseFilter">
                    <number-input
                        v-model="PurchasePrice"
                        :label="labelPurchasePrice"
                        inputmode="decimal"
                        @input="UpdateFilters()"
                    />
                </li>
                <li v-show="!ShowPurchaseFilter">
                    <number-input
                        v-model="HomeValue"
                        :label="labelHomeValue"
                        inputmode="decimal"
                        @input="UpdateFilters()"
                    />
                </li>
                <li v-show="ShowPurchaseFilter">
                    <number-input
                        v-model="DownPayment"
                        :label="labelDownPayment"
                        inputmode="decimal"
                        @input="UpdateFilters()"
                    />
                </li>
                <li v-show="!ShowPurchaseFilter">
                    <number-input
                        v-model="CurrentBalance"
                        :label="labelCurrentBalance"
                        inputmode="decimal"
                        @input="UpdateFilters()"
                    />
                </li>
                <li>
                    <a :href="SplitterHref" class="btn" :class="buttonColor">{{ DestinationButtonText }}</a>
                    <div v-if="DisplayTermsAndConditions" class="terms">{{ termsAndConditions }}</div>
                    <div class="disclosure-sec">
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="disclosureText"
                            :disclosure-tokens="disclosureTokens"
                            class="disclosures"
                        />
                        <span v-if="DisplayTermsAndConditions" class="optional-line">|</span>
                        <span v-if="DisplayTermsAndConditions" class="nmls-code">{{ nmlsCode }}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import LoanTypesList from '~/constants/loan-type-list';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import wwwUrlEnv from '~/helpers/www-url-env';

    export default {
        props: {
            buttonColor: {
                default: 'btn-blue', // btn-orange
            },
            mode: {
                default: 'mode-light', // mode-light
            },
            title: {
                default: '',
            },
            labelLoanType: {
                default: 'Loan Type',
            },
            loanType: {
                default: 'purchase',
            },
            labelZipCode: {
                default: 'ZIP Code',
            },
            labelPurchasePrice: {
                default: 'Purchase Price',
            },
            purchasePrice: {
                default: '0',
            },
            labelCurrentBalance: {
                default: 'Current Balance',
            },
            currentBalance: {
                default: 0,
            },
            destinationButtonText: {
                default: 'See Rates',
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            labelHomeValue: {
                default: 'Home Value',
            },
            homeValue: {
                default: '0',
            },
            labelDownPayment: {
                default: 'Down Payment',
            },
            downPayment: {
                default: 0,
            },
            refinanceSplitter: {
                default: 'wp-refinance',
            },
            mortgageSplitter: {
                default: 'wp-mortgage',
            },
            homeEquitySplitter: {
                default: 'wp-home-equity',
            },
            zipCode: {
                default: 28277,
            },
            termsAndConditions: {
                default: 'Terms & Conditions apply.',
            },
            nmlsCode: {
                default: 'NMLS#1136',
            },
            displayTermsAndConditions: {
                default: 'true',
            },

        },
        data() {
            return {
                LoanType: this.loanType,
                LoanTypeMortgageCTAList: LoanTypesList.MortgageCTAList,
                PurchasePrice: this.purchasePrice,
                CurrentBalance: this.currentBalance,
                HomeValue: this.homeValue,
                DownPayment: this.downPayment,
                ZipCode: this.zipCode,
                ShowZipCodeError: false,
                DestinationLinkOrId: 'wp-refinance',
                DestinationButtonText: this.destinationButtonText,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                ShowPurchaseFilter: true,
                SplitterHref: '',
                Title: this.title,
                TermsAndConditions: this.termsAndConditions,
                DisplayTermsAndConditions: this.displayTermsAndConditions === 'true',
            };
        },
        methods: {
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.zipCodeValidator()) {
                    GetLocation.methods.GetZipCode(this.ZipCode, this.checkLocationResponse);
                    this.ShowZipCodeError = false;
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            updateLocation(val) {
                this.StateCode = val.state;
                this.UpdateFilters();
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            checkLocationResponse(val) {
                if (!val.err) {
                    this.updateLocation(val);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            UpdateFilters() {
                if (this.title === '') {
                    this.Title = this.LoanType === 'purchase' || this.LoanType === 'refinance' ? 'See mortgage rates in your area' : 'See home equity rates for your home';
                }
                this.ShowPurchaseFilter = this.LoanType === 'purchase';
                this.DestinationLinkOrId = this.LoanType === 'purchase'
                    ? this.mortgageSplitter
                    : this.LoanType === 'refinance'
                        ? this.refinanceSplitter
                        : this.homeEquitySplitter;
                this.SplitterHref = `${wwwUrlEnv.getWWWURL()}/redirect/offers?id=${this.DestinationLinkOrId}&`;

                if (this.LoanType === 'purchase') {
                    const downpayment = Accounting.unformat(this.DownPayment);
                    const purchasePrice = Accounting.unformat(this.PurchasePrice);
                    const downPaymentCalculate = downpayment / purchasePrice;
                    const downPaymentPercentage = isNaN(downPaymentCalculate) || downPaymentCalculate === Infinity ? 0 : downPaymentCalculate.toFixed(3);

                    const downPaymentParam = Accounting.unformat(downPaymentPercentage) !== 0 ? `&DownPaymentPercent=${downPaymentPercentage}` : '';
                    const purchasePriceParam = purchasePrice !== 0 ? `&PurchasePrice=${purchasePrice}` : '';
                    this.SplitterHref = `${this.SplitterHref}ZipCode=${this.ZipCode}${purchasePriceParam}${downPaymentParam}`;
                } else {
                    const homeValue = Accounting.unformat(this.HomeValue);
                    const currentBalance = Accounting.unformat(this.CurrentBalance);
                    const homeValueParam = homeValue !== 0 ? `&EstimatedPropertyValue=${homeValue}` : '';
                    const currentBalanceParam = currentBalance !== 0 ? `&FirstMortgageBalance=${currentBalance}` : '';

                    this.SplitterHref = `${this.SplitterHref}ZipCode=${this.ZipCode}${homeValueParam}${currentBalanceParam}`;
                }
            },
        },
        mounted() {
            this.UpdateFilters();
        },
        components: {
            NumberInput,
            DropDown,
            ZipCodeInput,
            AdvertisingDisclosures,
        },
        mixins: [GetLocation],
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
